<template>
  <div class="app-download-area ptb-100">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-12">
          <div class="app-content" data-aos="fade-right">
            <span class="sub-title">Acesse de Qualquer Lugar</span>
            <h2>HawkCRM em todos os seus dispositivos</h2>
            <p>Gerencie seu negócio onde estiver. HawkCRM disponível para Web, Mobile e Desktop com sincronização em tempo real.</p>

            <div class="app-features">
              <div class="feature-item">
                <i class="ph-check-circle"></i>
                <span>Sincronização automática entre dispositivos</span>
              </div>
              <div class="feature-item">
                <i class="ph-check-circle"></i>
                <span>Acesso offline em apps mobile</span>
              </div>
              <div class="feature-item">
                <i class="ph-check-circle"></i>
                <span>Notificações push em tempo real</span>
              </div>
              <div class="feature-item">
                <i class="ph-check-circle"></i>
                <span>Interface otimizada para cada plataforma</span>
              </div>
            </div>

            <div class="download-buttons">
              <h3>Baixe Agora:</h3>
              <div class="buttons-grid">
                <a href="#" class="download-btn android">
                  <i class="ph-android-logo"></i>
                  <div>
                    <span>Disponível no</span>
                    <strong>Google Play</strong>
                  </div>
                </a>
                <a href="#" class="download-btn apple">
                  <i class="ph-apple-logo"></i>
                  <div>
                    <span>Baixar na</span>
                    <strong>App Store</strong>
                  </div>
                </a>
                <a href="#" class="download-btn windows">
                  <i class="ph-windows-logo"></i>
                  <div>
                    <span>Windows</span>
                    <strong>Desktop</strong>
                  </div>
                </a>
                <a href="#" class="download-btn web">
                  <i class="ph-globe"></i>
                  <div>
                    <span>Acesso</span>
                    <strong>Web App</strong>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-12">
          <div class="app-mockups" data-aos="fade-left">
            <div class="mockup-container">
              <!-- Mobile Mockup -->
              <div class="mockup mobile">
                <div class="mockup-screen">
                  <div class="mockup-header">
                    <div class="status-bar">
                      <span>9:41</span>
                      <div class="icons">
                        <i class="ph-wifi-high"></i>
                        <i class="ph-battery-charging"></i>
                      </div>
                    </div>
                    <div class="app-bar">
                      <i class="ph-list"></i>
                      <strong>Dashboard</strong>
                      <i class="ph-bell"></i>
                    </div>
                  </div>
                  <div class="mockup-content">
                    <div class="stat-card">
                      <i class="ph-chart-line-up"></i>
                      <div>
                        <span>Vendas Hoje</span>
                        <strong>R$ 12.450</strong>
                      </div>
                    </div>
                    <div class="stat-card">
                      <i class="ph-users-three"></i>
                      <div>
                        <span>Novos Leads</span>
                        <strong>23</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Tablet Mockup -->
              <div class="mockup tablet">
                <div class="mockup-screen">
                  <div class="tablet-header">
                    <strong>HawkCRM</strong>
                    <div class="tablet-stats">
                      <span>●</span>
                      <span>Online</span>
                    </div>
                  </div>
                  <div class="tablet-content">
                    <div class="pipeline-preview">
                      <div class="pipeline-column">
                        <div class="pipeline-header">Novos</div>
                        <div class="pipeline-card"></div>
                        <div class="pipeline-card"></div>
                      </div>
                      <div class="pipeline-column">
                        <div class="pipeline-header">Contato</div>
                        <div class="pipeline-card"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Floating Icons -->
              <div class="floating-icon icon-1">
                <i class="ph-android-logo"></i>
              </div>
              <div class="floating-icon icon-2">
                <i class="ph-apple-logo"></i>
              </div>
              <div class="floating-icon icon-3">
                <i class="ph-windows-logo"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Extra Info -->
      <div class="app-extra-info" data-aos="fade-up">
        <div class="info-grid">
          <div class="info-item">
            <i class="ph-shield-check"></i>
            <h4>Segurança Máxima</h4>
            <p>Criptografia end-to-end em todas as plataformas</p>
          </div>
          <div class="info-item">
            <i class="ph-download"></i>
            <h4>Instalação Simples</h4>
            <p>Configure em minutos e comece a usar imediatamente</p>
          </div>
          <div class="info-item">
            <i class="ph-arrows-clockwise"></i>
            <h4>Atualizações Automáticas</h4>
            <p>Sempre com as últimas funcionalidades e correções</p>
          </div>
          <div class="info-item">
            <i class="ph-headset"></i>
            <h4>Suporte 24/7</h4>
            <p>Equipe pronta para ajudar quando precisar</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Background Elements -->
    <div class="bg-gradient"></div>
  </div>
</template>

<script>
export default {
  name: 'AppDownload'
}
</script>

<style scoped>
/* ===== AREA BASE ===== */
.app-download-area {
  background: linear-gradient(135deg, #0a0a1a 0%, #16213e 100%);
  position: relative;
  overflow: hidden;
}

.bg-gradient {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at 30% 50%, rgba(109, 93, 252, 0.1) 0%, transparent 50%);
  pointer-events: none;
}

/* ===== CONTENT ===== */
.app-content {
  position: relative;
  z-index: 2;
}

.app-content .sub-title {
  display: inline-block;
  padding: 8px 20px;
  background: rgba(109, 93, 252, 0.2);
  border: 1px solid rgba(109, 93, 252, 0.5);
  border-radius: 50px;
  color: #C5BFFF;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 20px;
}

.app-content h2 {
  font-size: 42px;
  font-weight: 700;
  color: white;
  margin-bottom: 20px;
  line-height: 1.2;
}

.app-content p {
  font-size: 16px;
  color: #b8b8b8;
  line-height: 1.7;
  margin-bottom: 30px;
}

/* ===== FEATURES ===== */
.app-features {
  display: grid;
  gap: 15px;
  margin-bottom: 40px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #e0e0e0;
  font-size: 15px;
}

.feature-item i {
  font-size: 24px;
  color: #25D366;
  flex-shrink: 0;
}

/* ===== DOWNLOAD BUTTONS ===== */
.download-buttons h3 {
  font-size: 18px;
  font-weight: 700;
  color: white;
  margin-bottom: 20px;
}

.buttons-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}

.download-btn {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 15px 20px;
  background: rgba(255, 255, 255, 0.05);
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  text-decoration: none;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.download-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(109, 93, 252, 0.5);
  transform: translateY(-3px);
  box-shadow: 0 5px 20px rgba(109, 93, 252, 0.3);
}

.download-btn i {
  font-size: 32px;
  flex-shrink: 0;
}

.download-btn.android i {
  color: #3DDC84;
}

.download-btn.apple i {
  color: #ffffff;
}

.download-btn.windows i {
  color: #0078D4;
}

.download-btn.web i {
  color: #6D5DFC;
}

.download-btn div {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.download-btn span {
  font-size: 11px;
  color: #b8b8b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.download-btn strong {
  font-size: 15px;
  color: white;
  font-weight: 700;
}

/* ===== MOCKUPS ===== */
.app-mockups {
  position: relative;
  min-height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mockup-container {
  position: relative;
  width: 100%;
}

.mockup {
  position: absolute;
  background: #1a1a2e;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  border: 3px solid rgba(255, 255, 255, 0.1);
}

.mockup.mobile {
  width: 250px;
  height: 500px;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  animation: float 3s ease-in-out infinite;
}

.mockup.tablet {
  width: 350px;
  height: 450px;
  top: 50px;
  right: -50px;
  z-index: 1;
  opacity: 0.7;
  animation: float 3s ease-in-out infinite;
  animation-delay: 1s;
}

@keyframes float {
  0%, 100% { transform: translateY(0px) translateX(-50%); }
  50% { transform: translateY(-20px) translateX(-50%); }
}

.mockup.tablet {
  animation-name: floatTablet;
}

@keyframes floatTablet {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-15px); }
}

.mockup-screen {
  padding: 15px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Mobile Screen */
.status-bar {
  display: flex;
  justify-content: space-between;
  color: white;
  font-size: 11px;
  margin-bottom: 10px;
}

.status-bar .icons {
  display: flex;
  gap: 5px;
}

.app-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  margin-bottom: 15px;
  padding: 10px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
}

.mockup-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.stat-card {
  background: linear-gradient(135deg, rgba(109, 93, 252, 0.2) 0%, rgba(67, 97, 238, 0.2) 100%);
  padding: 15px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid rgba(109, 93, 252, 0.3);
}

.stat-card i {
  font-size: 28px;
  color: #6D5DFC;
}

.stat-card div {
  display: flex;
  flex-direction: column;
}

.stat-card span {
  font-size: 11px;
  color: #b8b8b8;
}

.stat-card strong {
  font-size: 18px;
  color: white;
  font-weight: 700;
}

/* Tablet Screen */
.tablet-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.tablet-stats {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
}

.tablet-stats span:first-child {
  color: #25D366;
}

.tablet-content {
  flex: 1;
}

.pipeline-preview {
  display: flex;
  gap: 10px;
}

.pipeline-column {
  flex: 1;
}

.pipeline-header {
  background: rgba(255, 255, 255, 0.05);
  padding: 8px;
  border-radius: 6px;
  font-size: 11px;
  color: white;
  text-align: center;
  margin-bottom: 8px;
}

.pipeline-card {
  background: rgba(109, 93, 252, 0.2);
  height: 60px;
  border-radius: 6px;
  margin-bottom: 8px;
  border: 1px solid rgba(109, 93, 252, 0.3);
}

/* ===== FLOATING ICONS ===== */
.floating-icon {
  position: absolute;
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid rgba(255, 255, 255, 0.2);
  animation: floatIcon 3s ease-in-out infinite;
}

.floating-icon i {
  font-size: 30px;
}

.icon-1 {
  top: 10%;
  left: 5%;
  animation-delay: 0s;
}

.icon-1 i {
  color: #3DDC84;
}

.icon-2 {
  bottom: 20%;
  left: 10%;
  animation-delay: 1s;
}

.icon-2 i {
  color: white;
}

.icon-3 {
  top: 60%;
  right: 5%;
  animation-delay: 2s;
}

.icon-3 i {
  color: #0078D4;
}

@keyframes floatIcon {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-15px); }
}

/* ===== EXTRA INFO ===== */
.app-extra-info {
  margin-top: 80px;
  position: relative;
  z-index: 2;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 30px;
}

.info-item {
  text-align: center;
  padding: 30px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.info-item:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(109, 93, 252, 0.3);
  transform: translateY(-5px);
}

.info-item i {
  font-size: 40px;
  color: #6D5DFC;
  margin-bottom: 15px;
}

.info-item h4 {
  font-size: 18px;
  font-weight: 700;
  color: white;
  margin-bottom: 10px;
}

.info-item p {
  font-size: 14px;
  color: #b8b8b8;
  margin: 0;
  line-height: 1.6;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 991px) {
  .app-content {
    margin-bottom: 60px;
  }

  .app-content h2 {
    font-size: 32px;
  }

  .mockup.tablet {
    display: none;
  }

  .floating-icon {
    display: none;
  }
}

@media (max-width: 576px) {
  .app-content h2 {
    font-size: 28px;
  }

  .buttons-grid {
    grid-template-columns: 1fr;
  }

  .mockup.mobile {
    width: 200px;
    height: 400px;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }
}
</style>